var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30.5896,
    fill: "white",
    stroke: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1104_1062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.2837 32.4777C47.2837 40.6566 40.6543 47.2837 32.4777 47.2837C24.3012 47.2837 17.6718 40.6566 17.6718 32.4777C17.6718 24.3036 24.3012 17.6718 32.4777 17.6718C40.6543 17.6718 47.2837 24.3036 47.2837 32.4777ZM32.875 22.5673C29.6215 22.5673 27.5464 23.9378 25.9169 26.3737C25.7058 26.6893 25.7764 27.1149 26.079 27.3443L28.1506 28.9151C28.4613 29.1507 28.9041 29.0947 29.1455 28.7884C30.212 27.4357 30.9433 26.6513 32.5666 26.6513C33.7862 26.6513 35.2948 27.4362 35.2948 28.6189C35.2948 29.513 34.5567 29.9722 33.3525 30.6473C31.9481 31.4346 30.0897 32.4145 30.0897 34.8658V35.1046C30.0897 35.5002 30.4104 35.821 30.8061 35.821H34.1494C34.545 35.821 34.8658 35.5002 34.8658 35.1046V35.025C34.8658 33.3258 39.8321 33.255 39.8321 28.6568C39.8321 25.194 36.2402 22.5673 32.875 22.5673V22.5673ZM32.4777 37.3732C30.9634 37.3732 29.7315 38.6052 29.7315 40.1195C29.7315 41.6338 30.9634 42.8658 32.4777 42.8658C33.9921 42.8658 35.224 41.6338 35.224 40.1195C35.224 38.6052 33.9921 37.3732 32.4777 37.3732Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1104_1062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.5672,
    height: 30.5672,
    fill: "white",
    transform: "translate(17.1941 17.1941)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/icon-question.6347b078906927514565d4a1650573cb.svg";
export { ForwardRef as ReactComponent };